import { ApiKeyOutput } from '@/slices/apiKeyListSlice';

export const createNewKeyName = (keyName: string, apiKeyOutputs: ApiKeyOutput[]) => {
  let max = 0;
  const matchingLabels = apiKeyOutputs
    .filter(apiKey => apiKey.label.includes(keyName))
    .map(apiKey => apiKey.label);
  for (const index of matchingLabels
    .map(label => label.split('(')[1]?.split(')')[0])
    .filter(Boolean)) {
    if (Number(index) > max) {
      max = Number(index);
    }
  }
  return `${keyName}(${max + 1})`;
};
